
<template>
  <div>
    <div class="mask" v-show="isShowSelect" @click="isShowSelect = !isShowSelect"></div>
    <el-popover
      placement="bottom-start"
      :width="width"
      trigger="manual"
      v-model="isShowSelect"
      @hide="popoverHide"
    >
      <el-tree
        class="common-tree"
        :style="styles"
        ref="tree"
        :expand-on-click-node="false"
        :data="data"
        :props="defaultProps"
        :show-checkbox="multiple"
        :node-key="nodeKey"
        :check-strictly="checkStrictly"
        :default-checked-keys="defaultCheckedKeys"
        :highlight-current="true"
        @node-click="handleNodeClick"
        @check-change="handleCheckChange"
        lazy
        :load="loadNode"
        @node-collapse="nodecollapse"
        @node-expand="nodeexpand"
      ></el-tree>

      <el-select
        :clearable="clear"
        :placeholder="placeholderOne"
        :style="selectStyle"
        slot="reference"
        ref="select"
        :disabled="disabled"
        v-model="selectedData"
        :multiple="multiple"
        @click.native="isShowSelect = !isShowSelect"
        class="tree-select"
        @clear="clearDept"
      >
        <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.id"></el-option>
      </el-select>
    </el-popover>
  </div>
</template>

<script>
import * as pmiDepts from '@/api/pmi/dept';
export default {
  name: 'tree-select',
  props: {
    clear: {
      type: Boolean,
      default() {
        return true;
      },
    },
    // 显示复选框情况下，是否严格遵循父子不互相关联
    checkStrictly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    // 默认选中的节点key数组
    checkedKeys: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    width: {
      type: Number,
      default() {
        return 250;
      },
    },
    placeholderOne: {
      type: String,
      default() {
        return '请选择';
      },
    },
    height: {
      type: Number,
      default() {
        return 300;
      },
    },

    widthOne: {
      type: Number,
      default() {
        return 230;
      },
    },
    typeOne: {
      type: Number,
      default() {
        return null;
      },
    },
    parentIdOne: {
      type: Number,
      default() {
        return 1;
      },
    },
  },
  data() {
    return {
      defaultCheckedKeys: [],
      isShowSelect: false, // 是否显示树状选择器
      options: [],
      selectedData: [], // 选中的节点
      style: 'width:' + this.width + 'px;' + 'height:' + this.height + 'px;',
      styles:
        'width:' + this.widthOne + 'px;' + 'height:' + this.height + 'px;',
      selectStyle: 'width:' + this.width + 'px;',
      checkedIds: [],
      checkedData: [],
      node: null,
      defaultProps: {
        label: 'label',
        children: 'zones',
        isLeaf: 'leaf',
        id: 'id',
      disabled: 'disabled',
      },
      nodeKey: 'id',
      data: [],
      multiple: false,
    };
  },
  mounted() {
    if (this.checkedKeys.length > 0) {
      if (this.multiple) {
        this.defaultCheckedKeys = this.checkedKeys;
        this.selectedData = this.checkedKeys.map((item) => {
          var node = this.$refs.tree.getNode(item);
          // console.log(node);
          return node.label;
        });
      } else {
        this.selectedData = this.checkedKeys[0].label;
      }
    }
  },
  methods: {
    clearDept() {
      this.$emit('clearDept');
    },
    // 节点关闭的时候，把弹窗收回
    nodecollapse(data, node) {
      if (node.level == 1) {
        this.style = 'width:' + this.width + 'px;' + 'height:' + 30 + 'px;';
        this.styles = 'width:' + 235 + 'px;' + 'height:' + 30 + 'px;';
      }
    },

    // 节点关闭的时候，把弹窗收回
    nodeexpand(data, node) {
      if (node.level == 1) {
        this.style =
          'width:' + this.width + 'px;' + 'height:' + this.height + 'px;';
        this.styles = 'width:' + 235 + 'px;' + 'height:' + this.height + 'px;';
      }
    },
    // 懒加载
    loadNode(node, resolve) {
      let _this = this;
      _this.node = node; //在data中记录当前node
      if (node.level === 0) {
        let data = {
          isFirst: 1,
          parentId: _this.parentIdOne,
        };

        pmiDepts.getDeptTree(data).then((response) => {
          // console.log(response);

          let tempData = [];
          response.data.forEach(function (item, index) {
            tempData.push({
              label: item.name,
              id: item.id,
              leaf: !item.isNext,
              nameReal: item.nameReal,
            });
          });
          resolve(tempData);

          // 第一次调用
          _this.getOrgslist();
        });
      }
      if (node.level >= 1) {
        _this.parentEventchaild(node.data.id, resolve);
      }
    },
    // 获取第二级节点数据
    parentEventchaild(parentId, resolve) {
      let _this = this;
      // let data = { parentId: parentId, type: _this.typeOne };
      let data = { parentId: parentId };
      pmiDepts.getDeptTree(data).then((response) => {
        let tempData = [];
        response.data.forEach(function (item, index) {
          tempData.push({
            label: item.name,
            id: item.id,
            leaf: !item.isNext,
            nameReal: item.nameReal,
          });
        });
        return resolve(tempData);
      });
    },
    // 展开第一层树
    getOrgslist() {
      let _this = this;
      _this.$nextTick(() => {
        // 动态加载左侧树结构的耳机菜单
        let nodedata = _this.node.childNodes[0];
        nodedata.expanded = true;
        nodedata.loadData();
      });
    },
    // 返回数据
    popoverHide() {
      if (this.multiple) {
        this.checkedIds = this.$refs.tree.getCheckedKeys(); // 所有被选中的节点的 key 所组成的数组数据
        this.checkedData = this.$refs.tree.getCheckedNodes(); // 所有被选中的节点所组成的数组数据
      } else {
        this.checkedIds = this.$refs.tree.getCurrentKey();
        this.checkedData = this.$refs.tree.getCurrentNode();
      }
      this.checkedData.label = this.checkedData.nameReal;
      this.$emit('popoverHide', this.checkedIds, this.checkedData);
    },
    // 节点被点击时的回调,返回被点击的节点数据
    handleNodeClick(data, node) {
      // console.log(node);
      if (!this.multiple) {
        let tmpMap = {};
        tmpMap.value = node.key;
        tmpMap.label = node.label;
        this.options = [];
        this.options.push(tmpMap);
        this.selectedData = node.label;
        this.isShowSelect = !this.isShowSelect;
      }
    },
    // 节点选中状态发生变化时的回调
    handleCheckChange() {
      var checkedKeys = this.$refs.tree.getCheckedKeys(); // 所有被选中的节点的 key 所组成的数组数据
      this.options = checkedKeys.map((item) => {
        var node = this.$refs.tree.getNode(item); // 所有被选中的节点对应的node
        let tmpMap = {};
        tmpMap.value = node.key;
        tmpMap.label = node.label;
        return tmpMap;
      });
      this.selectedData = this.options.map((item) => {
        return item.label;
      });
    },
  },
  watch: {
    isShowSelect(val) {
      this.style =
        // 隐藏select自带的下拉框
        this.$refs.select.blur();
    },
  },
};
</script>

<style scoped>
.mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  opacity: 0;
}
.common-tree {
  overflow: auto;
}
</style>

<style>
.tree-select .el-select__tags .el-tag .el-tag__close {
  display: none;
}
.tree-select .el-select__tags .el-tag .el-icon-close {
  display: none;
}
</style>